import styled from "styled-components"

const Style = styled.div`
  position: absolute;
  display: flex;
  gap: 12px;
  background: #FFFFFF;
  border: 0.2px solid #EAECF0;
  border-radius: 8px;
  padding: 12px var(--size);
  z-index: 2;

  label {
    margin-bottom: 0px;
    color: #344054;
    font-size: 12px;
    white-space: nowrap;
    font-weight: 500;

    &.strong {
      font-weight: 600;
    }
  }

  &.risk-cont {
    gap: 4px;

    .flex-c {
      dispaly: flex;
      flex-direction: column;
      justify-content: center;
    }

    .bullet {
      width: 7px;
      height: 7px;
      border-radius: 100%;
    }

    label {
      margin-right: 4px;

      &.strong {
        margin-right: 0;
        color: black;
        font-weight: 700;
      }
    }
  }
`;

export default function Tooltip({
  value,
  label,
  mouseX = 0,
  mouseY = 0,
  type,
  color,
  isEmpty = false,
  t = (s) => s,
}) {
  return (
    <Style
      style={{ top: mouseY, left: mouseX }}
      className={type === 'RISK' ? 'risk-cont' : ''}
    >
      {isEmpty ? (
        <label>{t('No information is available')}</label>
      ) : (
        <>
          {type === 'RISK' && (
            <div className="flex-c">
              <div className="bullet" style={{ background: color }} />
            </div>
          )}
          <label>{label}</label>
          <label className="strong">{value}</label>
        </>
      )}
    </Style>
  )
}
